import React from "react";

// Default data for the table
export const defaultPolicyTableData = [
  {
    policy: "",
    description: "",
    scope: "",
    accountablePerson: "",
    recognisedInstruments: "",
    availability: "",
  },
  {
    policy: "",
    description: "",
    scope: "",
    accountablePerson: "",
    recognisedInstruments: "",
    availability: "",
  },
  {
    policy: "",
    description: "",
    scope: "",
    accountablePerson: "",
    recognisedInstruments: "",
    availability: "",
  },
];

const PolicyTable = ({ policyData, setPolicyData }) => {
  const handleChange = (index, field, value) => {
    const updatedData = [...policyData];
    updatedData[index][field] = value;
    setPolicyData(updatedData);
  };

  React.useEffect(() => {
    if (!policyData || policyData.length === 0) {
      setPolicyData(defaultPolicyTableData);
    }
  }, []);

  return (
    <div
      style={{
        marginTop: "20px",
        overflowX: "auto",
        border: "0.6px solid #999",
        borderRadius: "12px",
        overflow: "hidden",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: 0,
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={tableHeaderStyle}>Policy</th>
            <th style={tableHeaderStyle}>Description of key contents</th>
            <th style={tableHeaderStyle}>Scope of policy (countries)</th>
            <th style={tableHeaderStyle}>
              Person accountable for implementation
            </th>
            <th style={tableHeaderStyle}>
              Internationally recognised instruments
            </th>
            <th style={tableHeaderStyle}>Availability</th>
          </tr>
        </thead>
        <tbody>
          {policyData.map((row, index) => (
            <tr key={index}>
              <td style={tableCellStyle}>
                <input
                  type="text"
                  placeholder="Enter"
                  value={row.policy}
                  onChange={(e) =>
                    handleChange(index, "policy", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={tableCellStyle}>
                <input
                  type="text"
                  placeholder="Enter"
                  value={row.description}
                  onChange={(e) =>
                    handleChange(index, "description", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={tableCellStyle}>
                <input
                  type="text"
                  placeholder="Enter"
                  value={row.scope}
                  onChange={(e) => handleChange(index, "scope", e.target.value)}
                  style={inputStyle}
                />
              </td>
              <td style={tableCellStyle}>
                <input
                  type="text"
                  placeholder="Enter"
                  value={row.accountablePerson}
                  onChange={(e) =>
                    handleChange(index, "accountablePerson", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={tableCellStyle}>
                <input
                  type="text"
                  placeholder="Enter"
                  value={row.recognisedInstruments}
                  onChange={(e) =>
                    handleChange(index, "recognisedInstruments", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={tableCellStyle}>
                <input
                  type="text"
                  placeholder="Enter"
                  value={row.availability}
                  onChange={(e) =>
                    handleChange(index, "availability", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles (consistent with previous tables)
const tableHeaderStyle = {
  padding: "14px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "15px",
};

const tableCellStyle = {
  padding: "14px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "15px",
};

const inputStyle = {
  width: "90%",
  padding: "10px",
  borderRadius: "8px",
  border: "0.6px solid #999",
  textAlign: "center",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
};

export default PolicyTable;
